/**
 * Interceptor Axios para capturar erros HTTP
 */

import type { AxiosError, AxiosInstance } from 'axios';
import { discordService } from './service';
import type { DiscordError } from './types';

/**
 * Determina a severidade baseada no status HTTP
 */
function getSeverityFromStatus(status?: number): 'low' | 'medium' | 'high' | 'critical' {
  if (!status) return 'medium';
  
  if (status >= 500) return 'critical';
  if (status === 401 || status === 403) return 'medium';
  if (status === 404) return 'low';
  if (status >= 400) return 'medium';
  
  return 'low';
}

/**
 * Configurar interceptor do Axios
 */
export function setupAxiosErrorInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      console.error('HTTP Error:', error);

      const discordError: DiscordError = {
        type: 'http',
        error: error,
        context: {
          url: error.config?.url,
          method: error.config?.method?.toUpperCase(),
          status: error.response?.status,
          statusText: error.response?.statusText,
          requestData: error.config?.data,
          responseData: error.response?.data,
          url_page: window.location.href,
          route: window.location.pathname,
          userAgent: navigator.userAgent,
          timestamp: new Date(),
        },
        severity: getSeverityFromStatus(error.response?.status),
      };

      // Enviar para Discord
      discordService.notifyError(discordError);

      // Re-throw o erro para que a aplicação possa tratar
      return Promise.reject(error);
    }
  );

  console.log('✅ Axios error interceptor configurado');
}

